import { render, staticRenderFns } from "./ShowApartmentNew.vue?vue&type=template&id=45530373&scoped=true&"
import script from "./ShowApartmentNew.vue?vue&type=script&lang=js&"
export * from "./ShowApartmentNew.vue?vue&type=script&lang=js&"
import style0 from "./ShowApartmentNew.vue?vue&type=style&index=0&id=45530373&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45530373",
  null
  
)

export default component.exports